import ApiService from '@/services/ApiService';

class AgentManagementService {
  static async listAgents({
    status = 'active',
    page = 1,
    includeTotals = true,
    q = '',
  } = {}) {
    const params = new URLSearchParams({
      status,
      page: String(page),
      include_totals: includeTotals ? 'true' : 'false',
    });
    if (q) params.set('search', q);

    return ApiService.get(`/api3/agents/list/?${params}`);
  }

  static async checkUserLimit() {
    return ApiService.get('/api3/users/check_limit');
  }

  // `noRedirect`: this endpoint answers 403 when the plan's user limit is
  // reached, which must reach the form instead of logging the user out.
  static async createAgent(payload) {
    return ApiService.post('/api3/agents/', payload, undefined, false, true);
  }
}

export default AgentManagementService;
